import tsetmcIcon from "src/Assets/Images/tsetmc.jpg";

export const TseIconLink=({ href }: {
  href?: string;
}) => href? <a
  href={href}
  target="_blank"
  rel="noopener noreferrer"
  title="نمایش اردربوک در TSETMC"
  onClick={(event) => event.stopPropagation()}
  className="inline-flex h-4 w-4 items-center justify-center"
>
  <img src={tsetmcIcon} alt="بورس" className="h-3 w-3 rounded-full" />
</a>:null;

export const Info=({ label,value }: {
  label: string;
  value: string|number|null|undefined;
}) => <div className="rounded bg-gray-50 px-2 py-1">
    <div className="text-[10px] text-gray-500">{label}</div>
    <div className="mt-1">{value?.toString()||"-"}</div>
  </div>;
